import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column flex-root bg-dark",
  id: "kt_app_root"
}
const _hoisted_2 = { class: "d-flex flex-column flex-column-fluid flex-lg-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-center w-lg-50 pt-15 pt-lg-0 px-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-center flex-lg-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas-solid fas-qrcode" }),
    /*#__PURE__*/_createElementVNode("h2", { class: "text-white fw-normal m-0" }, " Disable Two-Factor Authentication (2FA) for your account ")
  ])
], -1)
const _hoisted_4 = { class: "d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-6 p-sm-12 p-lg-20" }
const _hoisted_5 = { class: "bg-body d-flex flex-column align-items-stretch flex-center rounded-4 w-md-600px p-sm-20 p-5 rounded-3" }
const _hoisted_6 = { class: "d-flex flex-center flex-column flex-column-fluid px-lg-10 pb-15 pb-lg-20" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-gray-900 mb-3" }, "Please enter your password"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-muted fw-semibold fs-5 mb-5" }, " Disabling 2FA requires you to enter your password ")
], -1)
const _hoisted_8 = { class: "d-flex flex-column w-100" }
const _hoisted_9 = { class: "fv-plugins-message-container" }
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = { class: "d-flex mt-4 justify-content-end" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "spinner-border-sm spinner-border me-2"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Remove 2FA ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_Form, {
              "validation-schema": _ctx.validationSchema,
              onSubmit: _ctx.handleFormSubmit,
              class: "w-100 d-flex flex-column"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_Field, {
                    class: "form-control w-100 form-control-lg form-control-solid",
                    type: "password",
                    placeholder: "Enter your password",
                    name: "userPassword",
                    autocomplete: "off"
                  }),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_ErrorMessage, { name: "userPassword" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCancelButton && _ctx.handleCancelButton(...args))),
                    class: "me-4 btn-secondary btn d-flex justify-content-center align-items-center h-35px"
                  }, " Cancel "),
                  _createElementVNode("button", {
                    disabled: _ctx.loading,
                    type: "submit",
                    class: "btn-primary btn d-flex justify-content-center align-items-center h-35px"
                  }, [
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                      : _createCommentVNode("", true),
                    _hoisted_14
                  ], 8, _hoisted_12)
                ])
              ]),
              _: 1
            }, 8, ["validation-schema", "onSubmit"])
          ])
        ])
      ])
    ])
  ]))
}